export default {"src":"/_next/static/media/hexagon-chat.48395dba.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};